(function (doc, win) {
  // 判断是否为苹果手机
  function isIphone() {
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      return true;
    }
  }

  var docEl = doc.documentElement,
    resizeEvt = "orientationchange" in window ? "orientationchange" : "resize",
    recalc = function () {
      var clientWidth = docEl.clientWidth,
        clientHeight = docEl.clientHeight;
      if (!clientWidth) return;

      if (isIphone()) {
        // iframe嵌页面苹果机有问题 所以采用此种适配
        // if(window.orientation === 180 || window.orientation === 0){//竖屏   iphoneX微信端 此种不识别
        if (document.documentElement.clientWidth < 560) {
          // 竖屏  560 iphone5
          // console.log('ios竖屏')
          if (clientWidth < 320) {
            clientWidth = 320;
          }
          if (clientWidth >= 750) {
            docEl.style.fontSize = "100px";
          } else {
            docEl.style.fontSize = 100 * (clientWidth / 750) + "px";
          }
        } else {
          // 横屏  iphone各个机型有问题  所以区分判断
          // console.log('ios横屏')
          if (
            document.documentElement.clientWidth > 800 &&
            document.documentElement.clientWidth < 850
          ) {
            // X XS
            docEl.style.fontSize = 100 * (clientWidth / 1624) + "px";
          } else if (
            document.documentElement.clientWidth >= 850 &&
            document.documentElement.clientWidth < 900
          ) {
            // xsmax xr
            docEl.style.fontSize = 100 * (clientWidth / 1792) + "px";
          } else {
            docEl.style.fontSize = 100 * (clientWidth / 1334) + "px";
          }
        }
      } else {
        if (clientWidth <= clientHeight) {
          // 竖屏
          if (clientWidth < 320) {
            clientWidth = 320;
          }
          if (clientWidth >= 750) {
            docEl.style.fontSize = "100px";
          }
          docEl.style.fontSize = 100 * (clientWidth / 750) + "px";
        } else {
          // 横屏
          if (clientHeight < 320) {
            clientHeight = 320;
          }
          if (clientHeight >= 750) {
            docEl.style.fontSize = "100px";
          }
          docEl.style.fontSize = 100 * (clientHeight / 750) + "px";
        }
      }
    };
  if (!doc.addEventListener) return;
  win.addEventListener(resizeEvt, recalc, false);
  doc.addEventListener("DOMContentLoaded", recalc, false);
})(document, window);
